import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_ONORARIO_INCARICO } from '../../data.const';
import {
  setCurrentOnorarioIncaricoAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const retrieveOnorarioIncaricoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_ONORARIO_INCARICO),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_ONORARIO_INCARICO}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ incaricoLoader: true })),
        defer(() =>
          from(
            request({ path: `onorarioIncarico/${id}`, method: httpMethods.GET })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_ONORARIO_INCARICO}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentOnorarioIncaricoAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_ONORARIO_INCARICO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ incaricoLoader: false }))
      );
    })
  );

export default retrieveOnorarioIncaricoEpic;
